(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dept-of-thoughts-email-popup"] && !Shopify.designMode) return;
  try {
    
  class EmailCapturePopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-popup-dialog]');
      this.closeButton = this.querySelector('[data-popup-close]');
      this.backdrop = this.querySelector('[data-popup-backdrop]');
      this.success = this.querySelector('[data-popup-success]');
      this.storageKey = `email-capture-popup-${this.id}`;
      this.returnFocus = null;
      this.onKeydown = this.onKeydown.bind(this);
      this.onClose = this.close.bind(this);
      this.closeButton?.addEventListener('click', this.onClose);
      if (this.dataset.closeBehavior === 'button_and_backdrop') this.backdrop.addEventListener('click', this.onClose);
      if (this.success) { this.open(); this.markSeen(); return; }
      if (this.dataset.designMode === 'true') { this.open(); return; }
      if (this.dataset.homeOnly === 'true' && window.location.pathname !== this.dataset.homeUrl) return;
      if (!this.shouldOpen()) return;
      window.setTimeout(() => this.open(), Number(this.dataset.delay) || 0);
    }

    disconnectedCallback() {
      this.closeButton?.removeEventListener('click', this.onClose);
      this.backdrop?.removeEventListener('click', this.onClose);
      document.removeEventListener('keydown', this.onKeydown);
    }

    shouldOpen() {
      if (this.dataset.frequency === 'always') return true;
      try {
        if (this.dataset.frequency === 'session') return !window.sessionStorage.getItem(this.storageKey);
        const value = window.localStorage.getItem(this.storageKey);
        if (!value) return true;
        return Date.now() > Number(value);
      } catch (error) { return true; }
    }

    markSeen() {
      if (this.dataset.frequency === 'always') return;
      try {
        if (this.dataset.frequency === 'session') window.sessionStorage.setItem(this.storageKey, 'seen');
        else window.localStorage.setItem(this.storageKey, String(Date.now() + Number(this.dataset.frequency)));
      } catch (error) {}
    }

    open() {
      if (!this.hidden) return;
      this.returnFocus = document.activeElement;
      this.hidden = false;
      document.documentElement.classList.add('email-capture-popup-open');
      document.addEventListener('keydown', this.onKeydown);
      (this.success || this.querySelector('input[type="email"]') || this.closeButton || this.dialog).focus();
    }

    close() {
      this.markSeen();
      this.hidden = true;
      document.documentElement.classList.remove('email-capture-popup-open');
      document.removeEventListener('keydown', this.onKeydown);
      this.returnFocus?.focus?.();
    }

    onKeydown(event) {
      if (event.key === 'Escape' && this.dataset.closeBehavior === 'button_and_backdrop') { event.preventDefault(); this.close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  }
  if (!customElements.get('email-capture-popup')) customElements.define('email-capture-popup', EmailCapturePopup);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
